import amaLog from "../helpers/log";

const hostInfo = (): { isSeOcelot: boolean, siteName: string } => {
  let host: string = (typeof window !== 'undefined' ? window.ama?.hostName || window.location.hostname : '').toLowerCase();

  if (host.startsWith('www.')) {
    host = host.slice(4);
  }

  if (host === 'mabra.com') return { isSeOcelot: true, siteName: 'mabra' };

  const parts: string[] = host.split('.');

  if (parts.length !== 2) return { isSeOcelot: false, siteName: '' };

  const [siteName, tld] = parts;

  return { 
    isSeOcelot: (tld === 'se' && siteName !== 'recept'),
    siteName,
  };
};

export default function getModules() {
  const { siteName, isSeOcelot } = hostInfo();
  const isMotherhood = siteName === 'motherhood';
  const multivideoSites = ['allas'];
  const isMultivideoSite = multivideoSites.includes(siteName) ;
  const adTags = isMotherhood ? {
      autoPlay: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/7783179/motherhood.se/video/autoplay&description_url=__page-url__&tfcd=0&npa=0&sz=1920x1080&cust_params=pos%3Dauto%26category%3D__item-category__%26brand%3D__item-brand__%26creator%3D__item-creator__%26target_brand%3D__item-target_brand__&gdfp_req=1&unviewed_position_start=1&env=vp&impl=s&correlator=__random-number__&vpmute=1&vpa=auto&url=https%3A%2F%2Fwww.motherhood.se&vpos=preroll&ad_rule=1&cmsid=2546081&vid=__item-mediaid__&output=xml_vast4&plcmt=2',
      clickToPlay: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/7783179/motherhood.se/video/clicktoplay&description_url=__page-url__&tfcd=0&npa=0&sz=1920x1080&cust_params=pos%3Dclick%26category%3D__item-category__%26brand%3D__item-brand__%26creator%3D__item-creator__%26target_brand%3D__item-target_brand__&gdfp_req=1&output=xml_vast4&unviewed_position_start=1&env=vp&impl=s&correlator=__random-number__&vpmute=0&vpa=click&url=https%3A%2F%2Fwww.motherhood.se&vpos=preroll&cmsid=2546081&vid=__item-mediaid__&plcmt=1',
    } : null;
  const dmScript = isMultivideoSite ? 'https://ads.rubiconproject.com/prebid/13012_Allas_exp.28.js' : 'https://micro.rubiconproject.com/prebid/dynamic/13012.js';
  return {
    prebidScript: dmScript,
    adTags,
    useStats: true,
    useVideoStats: true,
    useLimitedAds: true,
    useGrowthbook: true,
    useSeenthis: true,
    useGLazyLoad: ['responsive_1', 'top_ad'],
    useDivModificationsOnMainCat: true,
    usePrebidVideo: true,
    useVerticals: isSeOcelot,
    usePlacementObserver: true,
    useObserverWithoutUniqueId: true,
    useSecondArticle: isSeOcelot,
    useLoadDMByAdsLib: true,
    usePlacementCheck: isSeOcelot,
    useLoadGptByAdsLib: isMotherhood,
    useLoadTopad: isSeOcelot,
    useRequestMultiVideoBids : isMultivideoSite,
  };
}
